/* eslint-disable no-confusing-arrow */
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import useGetQueryString from 'src/shared/hooks/useGetQueryString';
import styled from 'styled-components';
import { VIEW_MODES } from 'src/components/BookSearch/Constants';

import BookList from '../../BookSearch/BookList';
import { PAGE_SIZE } from '../constants';
import CurriculumsMenu from './CurriculumsMenu';
import OlogyBookFilter from './OlogyBookFilter';
import {
  BOOK_KIND,
  getBookListByCurriculum,
  getBooksByContent,
  getCurriculumInfo,
  getLocalBookList,
  getRecordGroups,
} from '../SchoolGradeOlogyApis';
import RecordGroupsMenu from './RecordGroupsMenu';

const Wrapper = styled.div`
  display: flex;
  padding-top: 20px;
`;

const BookListWrapper = styled.div`
  flex: 1;
`;

const MenuWrapper = styled.div``;

const Message = styled.h3`
  padding: 10px;
`;

const Title = styled.div`
  padding: 8px 20px;
  font-size: 14px;
  position: relative;
  margin: 0 20px 8px 20px;
  background-color: var(--title-backgournd-grey);

  &::before {
    position: absolute;
    top: 100%;
    content: '';
    height: 2px;
    width: 100px;
    background: var(--main-web-color);
    display: block;
  }
`;

const TitleOlogy = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: var(--title-backgournd-grey);
`;

const TitleIconWrapper = styled.div`
  height: 40px;
  width: 35px;
  background-color: var(--main-web-color);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

const TitleText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const OlogyTitleText = styled(TitleText)`
  max-width: 215px;
`;

const CurriculumTitleText = styled(TitleText)`
  max-width: 500px;
`;

const CustomOlogyBookFilter = styled(OlogyBookFilter)`
  margin-top: 16px;
`;

const GET_BY_TYPE = {
  ology: 'ology',
  group: 'group',
  type: 'type',
  content: 'content',
  other: 'other',
};

const GET_BY_TYPE_LABEL = {
  [GET_BY_TYPE.ology]: 'Tài liệu theo môn học',
  [GET_BY_TYPE.group]: 'Tài liệu theo bộ sưu tập',
  [GET_BY_TYPE.type]: 'Tài liệu theo loại',
  [GET_BY_TYPE.content]: 'Tài liệu theo nội dung',
};

const GET_BY_TYPE_DATA_KEY = {
  [GET_BY_TYPE.ology]: 'CurriculumName',
  [GET_BY_TYPE.group]: 'Name',
  [GET_BY_TYPE.type]: 'Name',
};

function CurrentMenus({
  id,
  booksByType,
  width,
  handleSelectMenuItem,
  bookKind = BOOK_KIND.book,
}) {
  if (booksByType === GET_BY_TYPE.type) {
    return (
      <RecordGroupsMenu width={width} onSelectGroup={handleSelectMenuItem} />
    );
  }
  return (
    <CurriculumsMenu
      width={width}
      id={id}
      onSelectCurriculum={handleSelectMenuItem}
      bookKind={bookKind}
    />
  );
}

function SchoolOlogyBooks({ bookKind = BOOK_KIND.book }) {
  const { id, groupId, Searchkey } = useGetQueryString();
  const [menuInfo, setMenuInfo] = useState();
  const [width, setWidth] = useState();
  const [isBooksLoading, setIsBooksLoading] = useState(false);
  const [bookList, setBookList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalBooks, setTotalBooks] = useState(0);
  const [resetFilter, setResetFilter] = useState({});
  const [infoMessage, setInfoMessage] = useState('');

  const wrapperRef = useRef(null);
  const currentSelectedItem = useRef();
  const currentSearchValue = useRef();

  const booksByType = useMemo(() => {
    if (id) {
      return GET_BY_TYPE.ology;
    }
    if (groupId) {
      return GET_BY_TYPE.group;
    }
    if (bookKind === GET_BY_TYPE.content) {
      return GET_BY_TYPE.content;
    }
    return GET_BY_TYPE.type;
  }, [id, groupId]);

  useLayoutEffect(() => {
    setWidth(wrapperRef.current?.offsetWidth);
  }, []);

  const setBookContent = useCallback((data) => {
    setIsBooksLoading(false);

    if (!data.length || !data[0].Success) {
      setTotalBooks(0);
      setBookList([]);
      if (data[0]?.Message) {
        setInfoMessage(data[0].Message);
      }
      return;
    }

    setBookList(data);
    setTotalBooks(data[0].TotalRecords);
  }, []);

  const getBookList = useCallback(
    ({
      curId = currentSelectedItem.current?.CurriculumID,
      page,
      searchValue = currentSearchValue.current,
      bookType,
    }) => {
      const currentGroupId = currentSelectedItem.current?.ID;
      setInfoMessage('');
      setIsBooksLoading(true);
      if (id) {
        getBookListByCurriculum({
          bookKind,
          id,
          curId,
          page,
          pageSize: PAGE_SIZE,
          searchValue,
          bookType,
        }).then((data) => {
          setBookContent(data);
        });
      } else if (currentGroupId) {
        getLocalBookList({
          groupId: currentGroupId,
          page,
          pageSize: PAGE_SIZE,
          searchValue,
          bookKind,
        }).then((data) => {
          setBookContent(data);
        });
      } else if (bookKind === GET_BY_TYPE.content) {
        getBooksByContent({
          page,
          pageSize: PAGE_SIZE,
          searchValue,
        }).then((data) => {
          setBookContent(data);
        });
      }
    },
    [currentSelectedItem.current]
  );

  useEffect(() => {
    if (booksByType === GET_BY_TYPE.ology) {
      getCurriculumInfo(id, bookKind).then((data) => {
        setMenuInfo(data);
      });
    } else if (booksByType === GET_BY_TYPE.group) {
      getRecordGroups().then((groups) => {
        const currentGroup = groups.find((g) => g.ID === +groupId);
        currentSelectedItem.current = currentGroup;

        getBookList({});
      });
    } else if (booksByType === GET_BY_TYPE.content) {
      if (Searchkey) {
        getBookList({
          searchValue: Searchkey,
        });
      } else {
        setInfoMessage('Hãy nhập nội dung tìm kiếm');
      }
    }
  }, []);

  const handleSelectMenuItem = (item) => {
    currentSelectedItem.current = item;
    getBookList({});
    setCurrentPage(1);
    setResetFilter({});
  };

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      getBookList({ page });
    },
    [getBookList, setCurrentPage]
  );

  const handleFilterChange = useCallback(
    ({ searchValue, bookType }) => {
      setCurrentPage(1);
      currentSearchValue.current = searchValue;
      getBookList({
        page: currentPage,
        searchValue: currentSearchValue.current,
        bookType,
      });
    },
    [getBookList]
  );

  // eslint-disable-next-line operator-linebreak
  const menuTitle = useMemo(() => {
    if (!menuInfo) {
      return '';
    }

    return bookKind === BOOK_KIND.ebookPacket
      ? menuInfo.PacketName
      : menuInfo.OlogyName;
  }, [menuInfo]);

  return (
    <Wrapper
      ref={wrapperRef}
      className="flex-col gap-[20px] sm:flex-row sm:gap-[4px]"
    >
      {![GET_BY_TYPE.group, GET_BY_TYPE.content].includes(booksByType) ? (
        <MenuWrapper>
          <TitleOlogy>
            <TitleIconWrapper>
              <FontAwesomeIcon icon={faBook} />
            </TitleIconWrapper>
            <OlogyTitleText title={menuTitle}>
              <b>
                {booksByType === GET_BY_TYPE.ology
                  ? menuTitle
                  : 'Loại tài liệu'}
              </b>
            </OlogyTitleText>
          </TitleOlogy>
          <CurrentMenus
            booksByType={booksByType}
            width={width}
            id={id}
            handleSelectMenuItem={handleSelectMenuItem}
            bookKind={bookKind}
          />
        </MenuWrapper>
      ) : (
        ''
      )}

      <BookListWrapper>
        <Title>
          <CurriculumTitleText>
            {GET_BY_TYPE_LABEL[booksByType]}:
            {currentSelectedItem.current ? (
              <b>
                &nbsp;
                {currentSelectedItem.current[GET_BY_TYPE_DATA_KEY[booksByType]]}
              </b>
            ) : (
              ''
            )}
          </CurriculumTitleText>
        </Title>
        <CustomOlogyBookFilter
          onFilter={handleFilterChange}
          resetFilter={resetFilter}
          shouldFilterByBookType={booksByType === GET_BY_TYPE.ology}
          initialSearchKey={Searchkey || ''}
        />
        {infoMessage ? (
          <Message>{infoMessage}</Message>
        ) : (
          <BookList
            bookList={bookList}
            isLoading={isBooksLoading}
            total={totalBooks}
            onPageChange={handlePageChange}
            currentPage={currentPage}
            pageSize={PAGE_SIZE}
            initialViewMode={
              bookKind === GET_BY_TYPE.content
                ? VIEW_MODES.list
                : VIEW_MODES.grid
            }
            shouldShowViewMode={bookKind !== GET_BY_TYPE.content}
          />
        )}
      </BookListWrapper>
    </Wrapper>
  );
}

export default SchoolOlogyBooks;
